export default {"src":"/_next/static/media/tech_info_icon_blue.f846562e.svg","height":16,"width":22};